import { gsap } from 'gsap';

const Animation = {
  mutations: {
    'ANIMATION/INIT_TOP_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.plants', { visibility: 'visible' });
      tl.set('.menu-nav', { visibility: 'visible' });
      tl.set('.link-nav', { visibility: 'visible' });
      tl.fromTo(
        '.plants',
        { opacity: 0, scale: 3, y: 500 },
        { opacity: 1, scale: 1, y: 0, duration: 1, ease: 'power1.out' },
        1,
      );
      tl.fromTo('.light-1', { opacity: 0 }, { opacity: 0.4 }, 2);
      tl.fromTo(
        '.light-1',
        { opacity: 0.4 },
        {
          opacity: 1,
          repeat: -1,
          yoyo: true,
          duration: 1.5,
          ease: 'power1.out',
        },
        2,
      );
      tl.fromTo('.light-2', { opacity: 0 }, { opacity: 0.4 }, 2);
      tl.fromTo(
        '.light-2',
        { opacity: 0.4 },
        {
          opacity: 1,
          repeat: -1,
          yoyo: true,
          duration: 1,
          ease: 'power1.out',
        },
        2,
      );
      tl.fromTo('.light-3', { opacity: 0 }, { opacity: 0.4 }, 2);
      tl.fromTo(
        '.light-3',
        { opacity: 0.4 },
        {
          opacity: 1,
          repeat: -1,
          yoyo: true,
          duration: 2,
          ease: 'power1.out',
        },
        2,
      );
      tl.fromTo(
        '.menu-nav',
        { opacity: 0, y: '-120%' },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: 'power1.out',
        },
        3.5,
      );
      tl.fromTo(
        '.link-nav',
        { opacity: 0, x: '120%' },
        {
          opacity: 1,
          x: 0,
          duration: 1.2,
          ease: 'power1.out',
        },
        3.8,
      );
    },
    'ANIMATION/INIT_TOP_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.lt-logo', { visibility: 'visible' });
      tl.set('.title', { visibility: 'visible' });
      tl.set('.playBtn', { visibility: 'visible' });
      tl.set('.playFree-btn', { visibility: 'visible' });
      tl.set('.characters', { visibility: 'visible' });
      tl.fromTo(
        '.lt-logo',
        { opacity: 0, y: '50' },
        { opacity: 1, y: '0', ease: 'power3.Out', duration: 0.3 },
        1.5,
      );
      tl.fromTo(
        '.title',
        { opacity: 0, y: '50' },
        { opacity: 1, y: '0', ease: 'power3.Out', duration: 0.3 },
        2,
      );
      tl.fromTo(
        '.playBtn',
        { opacity: 0, y: '50' },
        { opacity: 1, y: '0', ease: 'power3.Out', duration: 0.3 },
        2.5,
      );
      tl.fromTo(
        '.playFree-btn',
        { opacity: 0, y: '50' },
        { opacity: 1, y: '0', ease: 'power3.Out', duration: 0.3 },
        3,
      );
      tl.fromTo(
        '.characters',
        { opacity: 0, left: '-100px' },
        { opacity: 1, left: '0', ease: 'power3.Out', duration: 0.5 },
        3.5,
      );
    },
    'ANIMATION/INIT_CONTENT_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.bg-light-1', { visibility: 'visible' });
      tl.set('.bg-light-2', { visibility: 'visible' });
      //console.log('section 1 animate');
      tl.fromTo(
        '.bg-light-1',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0 },
        0.5,
      );
      tl.fromTo(
        '.bg-light-2',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0 },
        0.5,
      );
    },
    'ANIMATION/INIT_CONTENT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.bird', { visibility: 'visible' });
      tl.fromTo(
        '.bird',
        { opacity: 0, right: '-10%' },
        { opacity: 1, right: '3%', ease: 'power2.in' },
        1,
      );
    },
    'ANIMATION/DISABLE_CONTENT_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.bg-light-1', { visibility: 'hidden' });
      tl.set('.bg-light-2', { visibility: 'hidden' });
    },
    'ANIMATION/DISABLE_CONTENT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.bird', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_STORY_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.character3', { visibility: 'visible' });
      tl.set('.character1', { visibility: 'visible' });
      tl.set('.character2', { visibility: 'visible' });
      tl.set('.rock', { visibility: 'visible' });
      tl.set('.feather1', { visibility: 'visible' });
      tl.set('.feather2', { visibility: 'visible' });
      tl.set('.feather3', { visibility: 'visible' });
      tl.fromTo(
        '.rock',
        { opacity: 0, scale: 3, y: 500 },
        { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: 'expo.out' },
        0.2,
      );
      // 2 - 1 - 3
      tl.fromTo(
        '.character2',
        { opacity: 0, right: '100%' },
        { opacity: 1, right: '0', duration: 0.5, ease: 'power3.in' },
        0.5,
      );
      tl.fromTo(
        '.character1',
        { opacity: 0, right: '100%' },
        { opacity: 1, right: '0', duration: 0.5, ease: 'power3.in' },
        0.8,
      );
      tl.fromTo(
        '.character3',
        { opacity: 0, left: '-100%' },
        { opacity: 1, left: '0', duration: 0.5, ease: 'power3.in' },
        1.1,
      );
      tl.fromTo(
        '.feather1',
        { opacity: 0, top: '-100%' },
        {
          opacity: 1,
          top: '-22%',
          rotation: '90',
          duration: 2.5,
          ease: 'slow.in',
        },
        1.1,
      );
      tl.fromTo(
        '.feather2',
        { opacity: 0, top: '-100%', rotation: '90' },
        {
          opacity: 1,
          top: '30%',
          rotation: '0',
          duration: 2.8,
          ease: 'slow.in',
        },
        1.1,
      );
      tl.fromTo(
        '.feather3',
        { opacity: 0, top: '-100%', rotation: '90' },
        {
          opacity: 1,
          top: '20%',
          rotation: '0',
          duration: 3,
          ease: 'slow.in',
        },
        1.1,
      );
    },
    'ANIMATION/DISABLE_STORY_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.character3', { visibility: 'hidden' });
      tl.set('.character1', { visibility: 'hidden' });
      tl.set('.character2', { visibility: 'hidden' });
      tl.set('.rock', { visibility: 'hidden' });
      tl.set('.feather1', { visibility: 'hidden' });
      tl.set('.feather2', { visibility: 'hidden' });
      tl.set('.feather3', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_CLASS_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.purple-feather', { visibility: 'visible' });
      tl.set('.blue-feather', { visibility: 'visible' });
      tl.fromTo(
        '.purple-feather',
        { opacity: 0, bottom: '100%', rotation: '60' },
        {
          opacity: 1,
          bottom: '0',
          rotation: '0',
          duration: 2.2,
          ease: 'slow.in',
        },
        0.5,
      );
      tl.fromTo(
        '.blue-feather',
        { opacity: 0, top: '-100%', rotation: '90' },
        {
          opacity: 1,
          top: '-20%',
          rotation: '0',
          duration: 2,
          ease: 'slow.in',
        },
        0.5,
      );
    },
    'ANIMATION/DISABLE_CLASS_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.purple-feather', { visibility: 'hidden' });
      tl.set('.blue-feather', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_SKILL_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.purple-hair', { visibility: 'visible' });
      tl.fromTo(
        '.purple-hair',
        { opacity: 0, right: '-20%' },
        { opacity: 1, right: 0, ease: 'power3.in' },
      );
    },
    'ANIMATION/DISABLE_SKILL_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.purple-hair', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_SUMMON_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.fire',
        { opacity: 1, scaleX: 1 },
        {
          opacity: 0.7,
          skewX: 0.5,
          skewY: 0.5,
          //translateY: 0,
          scaleX: 1.01,
          repeat: -1,
          yoyo: true,
          duration: 1.6,
          ease: 'slow.out',
        },
      );
    },

    'ANIMATION/INIT_SUMMON_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.bow-girl', { visibility: 'visible' });
      tl.fromTo(
        '.bow-girl',
        { opacity: 0, left: '-10%' },
        {
          opacity: 1,
          left: '5%',
          ease: 'power3.out',
        },
      );
    },
    'ANIMATION/DISABLE_SUMMON_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.bow-girl', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_STAT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.magic-girl', { visibility: 'visible' });
      tl.fromTo(
        '.magic-girl',
        { opacity: 0, bottom: '-10%' },
        {
          opacity: 1,
          bottom: '0',
          ease: 'power3.out',
        },
      );
    },
    'ANIMATION/DISABLE_STAT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.magic-girl', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_COMPANION_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.kitty', { visibility: 'visible' });
      tl.set('.bear', { visibility: 'visible' });
      tl.set('.bunny', { visibility: 'visible' });
      tl.fromTo(
        '.kitty',
        { opacity: 0, x: -1000 },
        { opacity: 1, x: 0, ease: 'power3.out' },
        0.3,
      );
      tl.fromTo(
        '.bunny',
        { opacity: 0, x: 1000 },
        { opacity: 1, x: 0, ease: 'power3.out' },
        0.5,
      );
      tl.fromTo(
        '.bear',
        { opcity: 0, x: 1000 },
        { opacity: 1, x: 0, ease: 'power3.out' },
        0.7,
      );
    },
    'ANIMATION/DISABLE_COMPANION_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.kitty', { visibility: 'hidden' });
      tl.set('.bear', { visibility: 'hidden' });
      tl.set('.bunny', { visibility: 'hidden' });
    },
    'ANIMATION/INIT_COMBAT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.jewelstar', { visibility: 'visible' });
      tl.fromTo(
        '.jewelstar',
        { opacity: 0, left: '-10%' },
        {
          opacity: 1,
          left: '12px',
          ease: 'power3.out',
        },
      );
    },
    'ANIMATION/DISABLE_COMBAT_SECTION_INNER': function() {
      const tl = gsap.timeline();
      tl.set('.jewelstar', { visibility: 'hidden' });
    },

    'ANIMATION/ACTIVE_CLASS_SLIDER': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.class-main-image',
        { y: '5' },
        {
          y: '-5',
          yoyo: true,
          repeat: -1,
          duration: 1.5,
          ease: 'power1.inOut',
        },
      );
    },
    'ANIMATION/DISABLE_CLASS_SLIDER': function() {
      const tl = gsap.timeline();
      tl.set('.class-main-image', { y: 0, duration: 0 });
    },
  },
};

export default Animation;
